import { Card, Divider } from "antd";

import ForgotPasswordForm from "./components/forgotPasswordForm";
import { styles } from "./styles/forgotPasswordStyles";
import logo from "../../assets/images/airp_logo.png";
import dayjs from "../../config/dayjs";

export default function ForgotPasswordPage() {
  return (
    <div style={styles.container}>
      <div style={{ width: "100%" }}>
        <div style={styles.logoContainer}>
          <img alt="logo" src={logo} style={styles.logo} />
        </div>
        <Card title="Forgot Password" style={styles.forgotPasswordCard}>
          <ForgotPasswordForm />

          <div style={styles.loginText}>
            Click <a href="/login">here</a> to login.
          </div>
          <Divider />
          <div style={styles.copyright}>© AIRP {dayjs().year()}</div>
        </Card>
      </div>
    </div>
  );
}
